import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';

import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable()
export class InvitationLinkService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  invitationLink(userId: string) {
    return this.httpClient.get<{ invitationLink: string }>(
      `${this.apiBaseUrl}users/${encodeURIComponent(userId)}/invitation`,
    );
  }
}
